import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import PasswordField, { pwStrong } from "@/components/PasswordField";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pwStrong(pw)) return toast.error("Please choose a stronger password (see the requirements).");
    if (pw !== pw2) return toast.error("Passwords don't match.");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, new_password: pw }); setDone(true); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Couldn't reset password"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-[520px] mx-auto px-6 md:px-12 py-20">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Account access</p>
      <h1 className="font-serif text-5xl tracking-tighter">Reset password.</h1>

      {!token ? (
        <p className="mt-8 text-muted-foreground">This link is missing its token. Please request a new one from <Link to="/forgot-password" className="underline hover:text-foreground">Forgot password</Link>.</p>
      ) : done ? (
        <div className="mt-8 border border-foreground p-6">
          <p className="font-serif text-2xl tracking-tight">Password reset.</p>
          <p className="mt-2 text-muted-foreground">You can now sign in with your new password.</p>
          <button onClick={() => nav("/login")} className="inline-block mt-5 bg-foreground text-background px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-[hsl(var(--accent))]">Sign in</button>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 border border-foreground p-6 md:p-8 space-y-5">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">New password</p>
            <PasswordField value={pw} onChange={(e) => setPw(e.target.value)} strength required />
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Confirm new password</p>
            <PasswordField value={pw2} onChange={(e) => setPw2(e.target.value)} required />
          </div>
          <button disabled={busy || !pwStrong(pw) || pw !== pw2} className="bg-foreground text-background px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-[hsl(var(--accent))] disabled:opacity-50">
            {busy ? "Resetting…" : "Reset password"}
          </button>
        </form>
      )}
    </div>
  );
}
